import toast from "react-hot-toast";

export default function toastMessage(type = "error", message) {
  const normalizeMessage = (input) => {
    if (!input) return "";
    if (typeof input === "string") return input;

    const status = input?.response?.status;
    if (status === 500) return "Server error (500). Please try again later.";
    if (status === 401) return "Access denied. Please log in again.";
    if (status === 404) return "Resource not found.";

    const responseData = input?.response?.data;
    if (typeof responseData?.message === "string") return responseData.message;
    if (typeof responseData?.error === "string") return responseData.error;
    if (typeof responseData?.error?.error === "string")
      return responseData.error.error;
    if (typeof input?.message === "string") return input.message;

    return "Something went wrong. Please try again.";
  };

  let new_message = normalizeMessage(message);

  if (!new_message) return;

  if (
    typeof new_message === "string" &&
    new_message.includes("E11000 duplicate key error")
  ) {
    new_message = "Data already exists";
  }

  if (new_message.includes("Network Error")) {
    new_message =
      "Unable to reach the server. Please check your network connection and try again.";
  }

  new_message = new_message.replace(/\s+/g, " ").trim();

  // Deduplicate: use message content as toast ID so identical messages collapse into one
  const toastId = `${type}__${new_message.slice(0, 80)}`;

  const config = {
    position: "top-right",
    duration: 5000,
    id: toastId,
  };

  if (type === "error") {
    toast.error(new_message, {
      ...config,
      style: { background: "#ffcfcf", color: "#f50707" },
    });
  } else if (type === "success") {
    toast.success(new_message, {
      ...config,
      style: { background: "#d5f7d6", color: "green" },
    });
  } else {
    toast(new_message, {
      ...config,
      style: { background: "#a6d7ff", color: "#078ece" },
    });
  }
}
